<template>
  <footer>
    <div class="block block--left">
      <div class="container" id="contact">
        <h1>Imaš pitanje?</h1>
        <p>Stalno provjeravamo inbox, javi se i uljepšaj nam dan.</p>
        <a class="button" href="mailto:days@dump.hr">POŠALJI MAIL</a>  
      </div>
    </div>
    <div class="block block--right">
      <div class="container">
        <h1>Registriraj se</h1>
        <p>Zainteresirali smo te da dođeš na konferenciju?</p>
        <button class="button" v-on:click="$emit('showRegistrationModal')">REGISTRACIJA</button>
      </div>
    </div>
    <ul class="container social">
      <li>
        <a aria-label="Posjeti facebook" href="https://www.facebook.com/dumpdays/" target="_blank" rel="noreferrer">
          <img src="../../assets/social/facebook.svg" alt="Facebook link">
        </a>
      </li>
      <li>
        <a aria-label="Posjeti youtube" href="https://www.youtube.com/channel/UC7PMtpZobjWu84C-x_nRW5w" target="_blank" rel="noreferrer">
          <img src="../../assets/social/youtube.svg" alt="Youtube link">
        </a>
      </li>
      <li>
        <a aria-label="Posjeti instagram" href="https://www.instagram.com/dump_days/" target="_blank" rel="noreferrer">
          <img src="../../assets/social/instagram.svg" alt="Instagram link">
        </a>
      </li>
    </ul>
    <div class="container copyright">
      <p>@DUMP Udruga mladih programera, 2019</p>
      <a aria-label="Posjeti stranicu prošle konferencije" href="https://2018.days.dump.hr/" target="_blank" rel="noreferrer">DUMP Days 2018 &#10230;</a>
      <a aria-label="Posjeti stranicu DUMP-a" class="logo" href="https://dump.hr" target="_blank" rel="noreferrer">
        <img src="../../assets/dump-logo.png" alt="DUMP link">
      </a>
    </div>
  </footer>
</template>

<style scoped>
footer {
  margin-top: 150px;
}

.block--right {
  padding-bottom: 135px;
  padding-top: 95px;
  background-color: #2e3941;
  background-image: url("../../assets/patterns/visual-identity.png");
  background-position: left bottom;
}
.block h1 {
  font-family: "Fuse V.2 Display";
  font-size: 36px;
  font-weight: 800;
  line-height: 44px;
  color: #fff;
}

.block--left h1 {
  color: #000;
}

.block p {
  margin-top: 8px;
  margin-bottom: 22px;
  color: rgb(0, 0, 0, 0.6);
  font-family: "Fuse V.2 Display";
  font-size: 18px;
  line-height: 31px;
}

.zainteresirali-smo-t-copy {
  height: 72px;
  width: 250px;
}

.block--left {
  padding-bottom: 65px;
  padding-top: 115px;
}

.social {
  display: flex;
  justify-content: space-between;
  transform: translateY(-60%);
  list-style-type: none;
}

.social li {
  justify-content: center;
  align-items: center;
  display: flex;
  box-shadow: 0 11px 44px 0 rgba(0, 0, 0, 0.19);
  background-color: #ffffff;
  padding: 18px;
  width: 70px;
  height: 70px;
}

.social a {
  text-decoration: none;
}

.social img {
  max-width: 100%;
}

.copyright {
  padding-top: 70px;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
}

.copyright a {
  display: inline-block;
}

.copyright a.logo {
  display: block;
  margin-left: auto;
  margin-top: -30px;
  max-width: 100px;
}

.copyright img {
  width: 100%;
  opacity: 0.45;
}

.copyright p,
.copyright a {
  color: rgb(0, 0, 0, 0.45);
  font-family: "Fuse V.2 Display";
  font-size: 14px;
  line-height: 31px;
}

.copyright a {
  text-decoration: none;
  text-transform: uppercase;
  padding-right: 10px;
}

.block--right p {
  color: rgba(255, 255, 255, 0.6);
}

@media screen and (min-width: 450px) {
  .copyright a.logo {
    max-width: 150px;
  }

  footer {
    margin-top: 0;
  }
}

@media screen and (min-width: 1024px) {
  footer::after {
    content: "";
    clear: both;
    display: table;
  }

  footer {
    margin-top: 150px;
  }

  .copyright a.logo {
    margin-top: -45px;
  }

  .block {
    float: left;
    width: 50%;
    padding-bottom: 140px;
    padding-top: 90px;
  }

  .block--left > .container {
    max-width: 450px;
    width: 80%;
    margin-right: 0;
  }

  .block p {
    max-width: 250px;
  }

  .social {
    justify-content: inherit;
  }

  .social li {
    margin-right: 60px;
  }

  .copyright img {
    display: inline-block;
    height: 40px;
    max-width: 100%;
  }
}

@media screen and (min-width: 1094px) {
  .copyright {
    margin-top: 60px;
    padding-top: 10px;
    padding-bottom: 5px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    margin-bottom: 25px;
  }

  .copyright a.logo {
    margin: 0;
  }
}

@media screen and (min-width: 1120px) {
  .block--left > .container {
    max-width: calc(50vw - ((100vw - 1120px) / 2));
  }
}
</style>

<script>
export default {
  name: "Footer"
};
</script>
